import { Component, HostListener } from '@angular/core';

import { AccountService } from './_services';
import { User } from './_models';
import { environment } from '@environments/environment';
import { OneSignal } from 'onesignal-ngx';

import * as firebase from 'firebase/app';
import 'firebase/messaging';

import { AngularFireMessaging } from '@angular/fire/compat/messaging';

declare const window: any;

@Component({ selector: 'app-root', templateUrl: 'app.component.html' })
export class AppComponent {

  messageReceived = false;
  messageData: any = {};
  tokenSent = false;
  isNotificationPermissionGranted = false;
  business_type: string = '';

  @HostListener('window:beforeinstallprompt', ['$event'])
  user?: User | null;
  loadAPI: Promise<any>;

  constructor(private accountService: AccountService,
    private oneSignal: OneSignal,
    private afMessaging: AngularFireMessaging) {
    this.accountService.user.subscribe(x => this.user = x);
    this.loadAPI = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
    this.business_type = localStorage.getItem('business_type') || '';


    this.oneSignal.init({
      appId: `${environment.OneSignalAppId}`,
      autoRegister: false,
      autoResubscribe: true,
    });
    this.oneSignal.getUserId().then(playerId => {
      if (playerId) {
        this.accountService.createOneSignal(
          localStorage.getItem('_restId'),
          playerId,
          this.business_type // use the property
        ).subscribe(res => {
          console.log('Player ID saved with business_type:', res);
        });
      }
    });

    this.oneSignal.setSubscription(true);
    this.oneSignal.setExternalUserId(localStorage.getItem('_restId'));
    console.log('Business Type being sent:', this.business_type);

    this.requestPermission();
    this.initFirebaseMessaging();
  }


  logout() {
    this.accountService.logout();
  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")

    if (!isFound) {
      var dynamicScripts = [
        'assets/js/jquery.min.js',
        'assets/js/bootstrap.min.js',
        'assets/js/slick.min.js',
        'https://kit.fontawesome.com/451bf0ac75.js'
      ];

      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('body')[0].appendChild(node);
      }

    }
  }


  ngOnInit() {
    // this.requestPermission();
    // this.initFirebaseMessaging();
  }

  initFirebaseMessaging() {
    this.afMessaging.messages.subscribe((payload: any) => {
      console.log('Message received:', payload);
      this.messageData = payload.notification;
      this.messageReceived = true;

      const notificationTitle = payload?.notification?.title;
      const notificationOptions = {
        body: payload?.notification?.body,
        icon: 'assets/images/FatFox main logo.png'
      };
      const notification = new Notification(notificationTitle, notificationOptions);
      notification.onclick = (event) => {
        event.preventDefault();
        window.location.href = '/delivery-dashboard';
        notification.close();
      };

    });
  }

  requestPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          //this.isNotificationPermissionGranted = true;
          const fcmToken = localStorage.getItem('FCM_Token');
          if (!fcmToken) {
            this.afMessaging.requestToken
              .subscribe({
                next: (token: any) => {
                  console.log('Token:', token);
                  localStorage.setItem('FCM_Token', token);
                },
                error: (error: any) => {
                  console.error('Error while requesting notification permission:', error);
                }
              });
          } else {
            console.log('Token already sent:', fcmToken);
          }
        } else if (permission === 'denied') {
          console.log('Notification permission denied.');
          // localStorage.setItem('FCM_Token', '');
          localStorage.removeItem('FCM_Token');
        }
      });
    }
  }

}

